<lib-filter-list #productList [configService]="schedulersOverviewConfigService"></lib-filter-list>